/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';
import { ParamsbannerDeleteTypeUsingDelete } from '..';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description adminArticleScoreArticleIdUsingPut参数
 * @property `articleId` articleId
 * @property `[score]` score
 */
export interface ParamsadminArticleScoreArticleIdUsingPut {
  // pathParams
  /**
   * articleId
   */
  articleId: number;
  // queryParams
  /**
   * score
   */
  score?: number;
}
/**
 * @description adminUsingGet参数
 * @property `[authorUserName]` 作者邮箱前缀，用于查询，可不带
 * @property `[pageNum]` 当前页 默认1 可不带
 * @property `[pageSize]` 一页的大小，默认10，可不带
 * @property `[title]` 用于查询的文章标题，可不带
 */
export interface ParamsadminUsingGet {
  // queryParams
  /**
   * 作者邮箱前缀，用于查询，可不带
   */
  authorUserName?: string;
  /**
   * 当前页 默认1 可不带
   */
  pageNum?: number;
  /**
   * 一页的大小，默认10，可不带
   */
  pageSize?: number;
  /**
   * 用于查询的文章标题，可不带
   */
  title?: string;
}
export class AdminApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   *
   * @summary alterHotValue
   * @param params ParamsadminArticleScoreArticleIdUsingPut

   * @param opt ajax config
   * @returns models.CommonResultListAdminHotArticleVO
   */
  public adminArticleScoreArticleIdUsingPut = (
    params: ParamsadminArticleScoreArticleIdUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListAdminHotArticleVO> => {
    const path = '/api/admin/article/score/{articleId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('score' in params) p.query.score = params.score;
    ajax.check(params.articleId, 'articleId');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary healthCheckForBe


   * @param opt ajax config
   * @returns models.CommonResult
   */
  public adminHealthCheckForBeUsingGet = (
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/admin/healthCheckForBe';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary healthCheckForSso


   * @param opt ajax config
   * @returns models.CommonResult
   */
  public adminHealthCheckForSsoUsingGet = (
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/admin/healthCheckForSso';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary healthCheck


   * @param opt ajax config
   * @returns models.CommonResult
   */
  public adminHealthCheckUsingGet = (opt?: ExtraFetchParams): AjaxPromise<models.CommonResult> => {
    const path = '/api/admin/healthCheck';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary sendKStackWeekMail


   * @param opt ajax config
   * @returns {}
   */
  public adminSendMailUsingGet = (opt?: ExtraFetchParams): AjaxPromise<{}> => {
    const path = '/api/admin/sendMail';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary pageForArticleHot
   * @param params ParamsadminUsingGet

   * @param opt ajax config
   * @returns models.CommonResultPageableResultAdminHotArticleVO
   */
  public adminUsingGet = (
    params: ParamsadminUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultAdminHotArticleVO> => {
    const path = '/api/admin';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('authorUserName' in params) p.query.authorUserName = params.authorUserName;
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    if ('title' in params) p.query.title = params.title;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };

   /**
   *
   * @summary pageForArticleHot
   * @param params ParamsadminUsingGet

   * @param opt ajax config
   * @returns models.CommonResultPageableResultAdminHotArticleVO
   */
  public deleteArticle = (
    params: {articleId:number},
    opt?: ExtraFetchParams
  ): AjaxPromise<any> => {
    const path = '/api/admin/article/delete/';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('articleId' in params) p.query.articleId = params.articleId;
    // ajax.check(params.articleId, 'articleId');
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };

  public deleteQuestion = (
    params: {questionId:number},
    opt?: ExtraFetchParams
  ): AjaxPromise<any> => {
    const path = '/api/admin/question/delete/';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('questionId' in params) p.query.questionId = params.questionId;
    // ajax.check(params.articleId, 'articleId');
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };

  public deleteAnswer = (
    params: {answerId:number},
    opt?: ExtraFetchParams
  ): AjaxPromise<any> => {
    const path = '/api/admin/answer/delete/';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('answerId' in params) p.query.answerId = params.answerId;
    // ajax.check(params.articleId, 'articleId');
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new AdminApi();
